<script lang="ts">
    import type { SocialProof } from '@shared/types/types';

    interface Props {
        socialProof: SocialProof;
    }

    let { socialProof }: Props = $props();
</script>

{#if socialProof.popular || socialProof.shortage}
    <div class="reptile-social-proof-badges">
        {#if socialProof.popular}
            <oc-tag-v1 variant="info-primary" size={'50'}>Sehr beliebt</oc-tag-v1>
        {/if}
        {#if socialProof.shortage}
            <oc-tag-v1 variant="info-primary" size={'50'}>Fast ausverkauft</oc-tag-v1>
        {/if}
    </div>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-social-proof-badges {
        display: flex;
        flex-flow: row wrap;
        align-items: flex-end;
        gap: tokens.$oc-semantic-spacing-25;

        > * {
            margin-bottom: 0;
        }
    }
</style>
